import { computed, ref, watch } from 'vue';

/**
 * Account/user scoped saved views in localStorage (P2-FE-004).
 */
export function useQaSavedViews({ storageKey, maxViews = 12 } = {}) {
  const views = ref([]);
  const resolvedKey = computed(() =>
    typeof storageKey === 'function' ? storageKey() : String(storageKey || '')
  );

  const load = () => {
    const key = resolvedKey.value;
    if (!key) {
      views.value = [];
      return;
    }
    try {
      views.value = JSON.parse(localStorage.getItem(key) || '[]');
      if (!Array.isArray(views.value)) views.value = [];
    } catch (_err) {
      views.value = [];
    }
  };

  const persist = () => {
    const key = resolvedKey.value;
    if (!key) return;
    localStorage.setItem(key, JSON.stringify(views.value));
  };

  const saveView = (name, filters) => {
    const label = String(name || '').trim();
    if (!label) return false;
    views.value = [
      {
        name: label,
        filters: { ...(filters || {}) },
        savedAt: new Date().toISOString(),
      },
      ...views.value.filter(view => view.name !== label),
    ].slice(0, maxViews);
    persist();
    return true;
  };

  const removeView = name => {
    views.value = views.value.filter(view => view.name !== name);
    persist();
  };

  watch(resolvedKey, () => load(), { immediate: true });

  return {
    views,
    load,
    persist,
    saveView,
    removeView,
  };
}
